import forcePermissions from "./forcePermissions";

export { forcePermissions }